import type { CommandBarProviderProps } from '#components/command-bar/command-bar-types.js';

export const PACKAGE_SEARCH_PREFIX = 'p:';
export const PACKAGE_SEARCH_PROVIDER_ID = 'package-search';

export type PackageSearchProviderProps = CommandBarProviderProps;
